// opt-outs for autofill, password managers, and writing assistants — all in one place so solo + co-op can't drift
export const GRID_INPUT_GUARDS = {
  type: 'search',
  role: 'textbox',
  inputMode: 'none',
  autoComplete: 'off',
  autoCapitalize: 'characters',
  autoCorrect: 'off',
  spellCheck: false,
  enterKeyHint: 'next',
  'aria-autocomplete': 'none',
  'data-1p-ignore': '',
  'data-lpignore': 'true',
  'data-bwignore': 'true',
  'data-form-type': 'other',
  'data-gramm': 'false',
  'data-gramm_editor': 'false',
  'data-enable-grammarly': 'false',
  'data-lt-active': 'false',
} as const;
